"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_PHONES_ROUTES = exports.PREFIX = void 0;
exports.PREFIX = "/active-phones";
exports.ACTIVE_PHONES_ROUTES = {
    getActivePhones: () => `${exports.PREFIX}/getActivePhones`
};
//# sourceMappingURL=active-phones.api.js.map